import { render, staticRenderFns } from "./deleteDocument.vue?vue&type=template&id=ebae4fd4&"
import script from "./deleteDocument.vue?vue&type=script&lang=js&"
export * from "./deleteDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports